
import { Message } from "../ChatMessage";
import { supabase } from "@/lib/supabase";
import { handleError, ErrorSeverity } from "@/utils/errorHandler";
import { retryOperation } from "@/utils/connectionUtils";

export const sendMessageToAssistant = async (
  userMessage: string,
  contextMessages: Message[],
  userRole: string = 'bizadmin'
) => {
  const result = await supabase.functions.invoke('help-assistant', {
    body: {
      question: userMessage,
      chat_history: contextMessages,
      user_role: userRole
    }
  });
  
  if (!result.data) throw new Error("No response received");
  return result.data;
};

export const submitFeedback = async (
  messageContent: string,
  helpful: boolean,
  userId?: string,
  userRole: string = 'bizadmin'
) => {
  const { error } = await supabase.functions.invoke('help-assistant-feedback', {
    body: {
      message_content: messageContent,
      helpful,
      user_id: userId,
      user_role: userRole
    }
  });
  
  if (error) throw error;
};
